import { Box, BoxProps, Neighbors } from '@amzn/ring-ui-react-components';

export interface PostingTitleProps extends BoxProps {
  showLogo?: boolean;
}

export const PostingTitle = ({
  showLogo,
  children,
  ...props
}: PostingTitleProps) => (
  <Box mb={3} {...props}>
    {showLogo && (
      <Box mb={{ base: 2, m: 3 }}>
        <Neighbors boxSize={9} color="primary.500" />
      </Box>
    )}
    <Box
      textStyle={{
        base: 'heading-small-medium',
        m: 'heading-normal-medium',
      }}
      data-testid="posting-title"
    >
      {children}
    </Box>
  </Box>
);
